import API, { ensurePrefixed } from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { getCiudadano } from 'api/cuentaunicasir';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import { getContribuyente } from './contribuyentes';

// export const baseURI = '/empresas/panteones/';
export const baseURI = 'recaudacion/lotes-de-panteones/';
export const getPanteones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getPanteon = async (id, populate = false) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    if (!populate) {
      return formatReceived(response.data);
    }

    const { data } = response;

    if (data?.ciudadano) {
      const _ciudadano = await getCiudadano(data.ciudadano);
      data.ciudadano = formatReceived(_ciudadano);
    }
    if (data?.contributente) {
      const _contribuyente = await getContribuyente(data.contributente?.id);
      data.contribuyente = formatReceived(_contribuyente);
    }

    return formatReceived(data);
  } catch (err) {
    onError(err);
  }
  return null;
};

export const postPanteon = async (data, accion = 'PANTEONES') => {
  try {
    const values = { ...data };
    const accionInf = ensurePrefixed('CREAR_', accion);
    const response = await API.post(baseURI, values, {
      accionInf,
      idPadron: padronesEnum.LOTES_DE_PANTEON,
      clave: values.clave,
    });
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return null;
};

export const patchPanteon = async (id, data, accion = 'PANTEONES') => {
  try {
    const values = { ...data };
    const accionInf = ensurePrefixed('EDITAR_', accion);
    const response = await API.patch(`${baseURI}${id}`, values, {
      accionInf,
      idPadron: padronesEnum.LOTES_DE_PANTEON,
      clave: values.clave,
    });
    onSuccess(response, 'Actualizado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return null;
};

export const deletePanteon = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};

export const getPanteonesCaja = async (params) => {
  try {
    const response = await API.get('recaudacion/lotes-de-panteones-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return [];
};
